export default "__VITE_ASSET__BVm0uuRE__"